export default __webpack_public_path__ + "static/media/santa-crosss.372c2ba5.gif";